import loadAppManifest from './manifest-loader';
import loadAppAssets from './assets-loader';

export default (async function preLoad(name, locale, eventBus) {
  const manifest = await loadAppManifest(name, eventBus);
  return loadAppAssets(name, manifest, locale);
});
